/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createFalse } from '../../factoriesAny.js';
export var falseDependencies = {
  createFalse
};